/**
 * @Author: wuyang
 * @Date: 2023/12/26
 * @Description: ""
 */

interface IEnv {
	BASE_URL: string
	SOCKET_URL: string
	SOCKETIO_URL: string
}

const ENVS: Record<string, IEnv> = {
	development: require('./env.development').default,
	local: require('./env.local').default,
	fswy: require('./env.fswy').default,
	production: require('./env.production').default,
}

const env = ENVS[REACT_APP_ENV]

export const BASE_URL = env.BASE_URL
export const SOCKET_URL = env.SOCKET_URL
export const SOCKETIO_URL = env.SOCKETIO_URL

// 画笔颜色，图片切割透明图
export const DRAW_COLOR = '#32649F'
export const DRAW_OPACITY = 0.7

// 商品图画布大小限制
export const CANVAS_MAX_SIZE = 1999
export const CANVAS_MIN_SIZE = 500

// 图片上传最大值
export const UPLOAD_MAX_SIZE = 10 * 1024 * 1024
// 图片上传最大宽高比
export const UPLOAD_MAX_RATIO = 2
// 图片最大上传宽高值
export const UPLOAD_MAX_WIDTH = 2048
export const UPLOAD_MAX_HEIGHT = 2048
// 图片最小分辨率 512*512
export const UPLOAD_MIN_WIDTH = 512
export const UPLOAD_MIN_HEIGHT = 512

// 图片上传格式
export const UPLOAD_FORMAT = [
	'image/jpeg',
	'image/png',
	'image/webp',
	'image/bmp'
]

// 图片上传服务端最大值
export const UPLOAD_SERVER_MAX_SIZE = 1024

// Ai生成违规图片特殊标记
export const AI_VIOLATION_FLAG = 'Violating_regulations'
